import { Injectable } from "@angular/core";

/**
 * Funções de formatação de datas
 */
@Injectable({
    providedIn: 'root',
})
export class TimeFormatterService {
  
  /**
   * Formata um objeto date como 'YYYY-MM-DD hh:mm'
   * 
   * @param datetime data a ser formatada
   * @returns string de data no formato 'YYYY-MM-DD hh:mm'
   */
  format(datetime: Date, sep: string = '-', dayFirst: boolean = false) {

    let pad = (val: number) => val.toString().padStart(2, '0');
    let year = datetime.getFullYear();
    let month = pad(datetime.getMonth() + 1);
    let day = pad(datetime.getDate());
    let hour = pad(datetime.getHours());
    let minute = pad(datetime.getMinutes());

    let datePart = dayFirst === true ? 
      `${day}${sep}${month}${sep}${year}` :
      `${year}${sep}${month}${sep}${day}`;

    return `${datePart} ${hour}:${minute}`;
  }

  /**
   * Formata um objeto date como um array ['YYYY-MM-DD', 'hh:mm'] 
   * 
   * @param datetime data a ser formatada
   * @returns array com data e hora
   */
  dateParts(datetime: Date) {
    return this.format(datetime).split(' ');
  }
}